import React, { useState } from 'react';
import { Link, Navigate, useNavigate } from 'react-router-dom';
import {
  Box,
  Typography,
  Paper,
  TextField,
  Button,
  Alert,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from '@mui/material';
import { tenantApiFetch } from './tenantApi';
import { TenantCan } from '../components/tenant/TenantCan';

const JOB_TYPES = [
  { value: 'tenant_users_csv', label: 'Users (CSV)' },
  { value: 'tenant_audit_csv', label: 'Audit log (CSV)' },
  { value: 'tenant_usage_summary_csv', label: 'Usage summary (CSV)' },
  { value: 'tenant_roles_csv', label: 'Roles (CSV)' },
  { value: 'custom', label: 'Custom (filters only)' }
];

export default function TenantExportJobFormPage() {
  const navigate = useNavigate();
  const [jobType, setJobType] = useState('tenant_users_csv');
  const [filtersText, setFiltersText] = useState('{}');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setError(null);
    let filters_json;
    try {
      filters_json = JSON.parse(filtersText.trim() || '{}');
    } catch (_err) {
      setError('Filters must be valid JSON');
      setSaving(false);
      return;
    }
    try {
      const res = await tenantApiFetch('/api/tenant/export-jobs', {
        method: 'POST',
        body: { job_type: jobType, filters_json }
      });
      const json = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(json.error || 'Create failed');
      navigate(`/tenant/export-jobs/${json.job.id}`, { replace: true });
    } catch (err) {
      setError(err.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <TenantCan permission="tenant.exports.manage" fallback={<Navigate to="/tenant/export-jobs" replace />}>
      <Box>
        <Typography variant="h4" gutterBottom>
          New export job
        </Typography>
        <Button component={Link} to="/tenant/export-jobs" sx={{ mb: 2 }}>
          Back
        </Button>
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}
        <Paper sx={{ p: 2, maxWidth: 720 }}>
          <Box component="form" onSubmit={submit}>
            <FormControl fullWidth margin="normal">
              <InputLabel>Job type</InputLabel>
              <Select label="Job type" value={jobType} onChange={(e) => setJobType(e.target.value)}>
                {JOB_TYPES.map((o) => (
                  <MenuItem key={o.value} value={o.value}>
                    {o.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <TextField
              fullWidth
              label="Filters (JSON)"
              value={filtersText}
              onChange={(e) => setFiltersText(e.target.value)}
              margin="normal"
              multiline
              minRows={6}
              sx={{ fontFamily: 'monospace', fontSize: '0.85rem' }}
              helperText="Optional date ranges or column selections for future workers (placeholder export ignores most keys)."
            />
            <Box sx={{ mt: 2, display: 'flex', gap: 1 }}>
              <Button type="submit" variant="contained" disabled={saving}>
                {saving ? 'Creating…' : 'Create job'}
              </Button>
              <Button component={Link} to="/tenant/export-jobs">
                Cancel
              </Button>
            </Box>
          </Box>
        </Paper>
      </Box>
    </TenantCan>
  );
}
